import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function to merge Tailwind CSS classes
 * Used by shadcn/ui components
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get initials from a full name
 * @param fullName - Full name (e.g., "John Doe")
 * @returns Initials (e.g., "JD") or "U" if empty
 */
export function getInitials(fullName: string): string {
  if (!fullName || fullName.trim() === '') {
    return 'U' // Default for "User"
  }

  const names = fullName.trim().split(/\s+/)

  if (names.length === 1) {
    // Single name: return first letter
    return names[0][0].toUpperCase()
  }

  // Multiple names: return first letter of first and last name
  const firstInitial = names[0][0].toUpperCase()
  const lastInitial = names[names.length - 1][0].toUpperCase()

  return `${firstInitial}${lastInitial}`
}
